import { TENANT_REGION, REGIONS } from '../constants'
import { ProviderType, ConnectionLocation } from 'features/connections'

export function calculateRegion({
  tempLocation,
  provider,
  tenantId
}: {
  tempLocation: ConnectionLocation
  provider: ProviderType
  tenantId: string
}): string | undefined {
  const defaultRegion = TENANT_REGION[tenantId] || REGIONS.US

  const region = provider === ProviderType.BIGQUERY ? tempLocation?.region || defaultRegion : undefined

  return region
}
